document.addEventListener("DOMContentLoaded", () => {
    const arrow = document.querySelector(".arrow_align");

    if (!arrow.hasAttribute("data-listener-attached")) {
        arrow.setAttribute("data-listener-attached", "true");

        arrow.addEventListener("click", function () {
            const dropd = document.querySelector(".table_content_dropd");
            const icon = document.querySelector(".dropdown_btn");

            const currentMaxHeight = window.getComputedStyle(dropd).maxHeight;
            console.log("Computed max-height:", currentMaxHeight);

            if (currentMaxHeight !== "0px") {
                dropd.style.maxHeight = "0px";
                icon.classList.remove("flipped");
            } else {
                dropd.style.maxHeight = dropd.scrollHeight + "px";
                icon.classList.add("flipped");
            }
        });
    }
});

document.querySelector('a[href="#Frequently"]').addEventListener('click', function (e) {
    e.preventDefault();

    const faqsecion = document.querySelector('.accordion-group');
    const rect = faqsecion.getBoundingClientRect();
    const offset = rect.top + window.scrollY - 60;

    window.scrollTo({
        top: offset,
        behavior: 'smooth'
    });
});


document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
            const elementTop = targetElement.getBoundingClientRect().top;
            const scrollY = window.pageYOffset;
            const offsetBelow = -80;

            const targetPosition = elementTop + scrollY + offsetBelow;

            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }
    });
});

